import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Bell, Languages, Menu } from 'lucide-react';
import ProfileImg from '../../Images/avatar.png'
import { Badge } from '../../Components/ui';
import { sidebarActions } from '../../Components/layout/sidebarStore';
import { getPageTitle } from '../../Components/layout/pageTitles';
import '../../Components/layout/AppHeader/AppHeader.css'
import { CustomSelect } from '../../Components/CustomSelect';
import axios from "axios"
import { MAIN_URL } from '../../constants';
import api from '../../Components/RefreshToken/RefreshToken';

const Profile = ({ setRole, role, roleLabel }) => {
    const dropdownRef = useRef(null);
    const [notification, setNotification] = useState(false)
    const [mentors, setMentors] = useState()
    const TOKEN = localStorage.getItem("admin_token")
    const navigate = useNavigate()
    const openNotification = () => {
        setNotification(x => !x)
    }

    const changeRole = ((e) => {
        setRole(e.target.value)
        navigate("/")
        return localStorage.setItem(e.target.value, "role")
    })

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setNotification(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownRef]);

    useEffect(() => {
        api.get(`/management/staff/profile`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${TOKEN}`
            },
        }).then((response) => {
            setMentors(response?.data)

        }).catch((error) => {
            console.error('Error fetching mentors:', error);
        });

    }, []);

    const { pathname } = useLocation();
    const pageTitle = getPageTitle(pathname);

    return (
        <header className='ui-header'>
            <div className='ui-header__left'>
                <button
                    type="button"
                    className="ui-header__icon-btn ui-header__menu-btn"
                    onClick={sidebarActions.openMobile}
                    aria-label="Menyuni ochish"
                >
                    <Menu aria-hidden="true" />
                </button>
                {pageTitle && <h1 className="ui-header__title">{pageTitle}</h1>}
            </div>
            <div className='ui-header__right'>
                <div className="ui-header__lang">
                    <Languages className="ui-header__lang-icon" aria-hidden="true" />
                    <select className="ui-header__lang-select" aria-label="Til">
                        <option value="en">En</option>
                        <option value="ru">Ru</option>
                        <option value="uz">Uz</option>
                    </select>
                </div>
                <div className="ui-header__notifications" ref={dropdownRef}>
                    <button
                        type="button"
                        onClick={openNotification}
                        className="ui-header__icon-btn"
                        aria-label="Notifications"
                        aria-expanded={notification}
                    >
                        <Bell aria-hidden="true" />
                    </button>
                    {
                        notification && (
                            <div>

                                {
                                    role === "admin" || role === "super_admin" ? (
                                        <ul className="ui-header__menu">
                                            <li className="ui-header__menu-item" onClick={openNotification}>
                                            </li>
                                            <li className="ui-header__menu-item" onClick={openNotification}>
                                                <Link to="/notifications/teacher-complaints" className="ui-header__menu-link">
                                                    Teacher complaints
                                                </Link>
                                            </li>
                                            <li className="ui-header__menu-item" onClick={openNotification}>
                                                <Link to="/notifications/student-complaints" className="ui-header__menu-link">
                                                    Student complaints
                                                </Link>
                                            </li>
                                            <li className="ui-header__menu-item" onClick={openNotification}>
                                                <Link to="/notifications/student-application" className="ui-header__menu-link">
                                                    Student application
                                                </Link>
                                            </li>
                                        </ul>
                                    ) : ("")
                                }

                                {
                                    role === "mentor" && (
                                        <ul className="ui-header__menu">
                                            <li className="ui-header__menu-item" onClick={openNotification}>
                                                <Link to="/notifications/confirmations" className="ui-header__menu-link">
                                                    Confirmations
                                                </Link>
                                            </li>
                                            <li className="ui-header__menu-item" onClick={openNotification}>
                                                <Link to="/notifications/student-complaints" className="ui-header__menu-link">
                                                    Student complaints
                                                </Link>
                                            </li>
                                        </ul>
                                    )
                                }

                            </div>
                        )
                    }
                </div>
                {/* <CustomSelect
                    placeholder={"Choose a role"}
                    options={["admin", "teacher", "super_admin"]}
                    onChange={(value) => changeRole(value)}
                    name={"role"}
                    customStyle={{ padding: "0" }}
                /> */}
                <div className="ui-header__profile">
                    <img src={ProfileImg} alt="" className="ui-header__avatar" />
                    <div className="ui-header__profile-text">
                        <span className="ui-header__profile-name">{mentors?.first_name} {mentors?.last_name}</span>
                        <Badge variant="brand" size="sm">{roleLabel || role}</Badge>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Profile;
